import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import UserData from "../classes/api/result/accountmodule/UserData";

import UserListDto from "../classes/dtos/accountmodule/UserListDto";

const UserApi = {

    EnsureStandardAccountAsync: async function (token: string): Promise<UserData> {
        const response = await fetch(Settings.api_url + "/User/EnsureStandardAccount", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        });

        if (response.status === 200) {
            let userData = await response.json();
            return new UserData(userData.userId, userData.customerId);
        }

        return new UserData(-1, -1);
    },

    GetUserListAsync: async function (filteredByWorkspace: boolean): Promise<ProcessingResult<UserListDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/User/GetUsers?filteredByWorkspace=" + filteredByWorkspace, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.users.map((e: { id: number; email: string; firstName: string; lastName: string; role: number; status: number; roleGroupIds: number[] }) => new UserListDto(e.id, e.email, e.firstName, e.lastName, e.role, e.status, e.roleGroupIds ?? [])));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());

    },

    ChangeUserRoleAsync: async function (userId: number, userRole: number): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/User/ChangeUserRole", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'userId': userId,
                'userRole': userRole
            })
        });

        if (response.status === 200) {
            let result = await response.json();
            return ProcessingResult.Ok(result);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    ChangeUserRoleGroupsAsync: async function (userId: number, roleGroupIds: number[]): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/User/ChangeUserRoleGroups", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'userId': userId,
                'roleGroupIds': roleGroupIds
            })
        });

        if (response.status === 200) {
            let result = await response.json();
            return ProcessingResult.Ok(result);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },
};

export default UserApi;